import Vue from 'vue'
export const LocationPickerEventBus = new Vue()